import gsap from 'gsap'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { createEvent } from './_helpers'
import {
  preloader,
  preloaderBlackBlock,
  preloaderGreenBlock,
  preloaderLogo,
} from './_constants'

export default function preloaderAnimation(hasSeenPreloader) {
  if (!hasSeenPreloader) {
    gsap
      .timeline({
        onStart: () => {
          disableBodyScroll(document.body)
        },
      })
      .to(preloaderLogo, { y: 0, duration: 0.4 })
      .to(preloaderGreenBlock, { y: 0, duration: 0.8 }, '+=0.6')
      .to(preloaderLogo, { color: '#fff', duration: 0.4 }, '-=0.6')
      .to(preloaderLogo, { yPercent: 100, duration: 0.4 }, '+=0.6')
      .to(
        preloaderBlackBlock,
        {
          y: 0,
          duration: 0.8,
        },
        '+=0.6'
      )
      .to(preloader, { opacity: 0.5, duration: 0.2 }, '+=0.8')
      .set(preloader, {
        onComplete: () => {
          enableBodyScroll(document.body)
          window.dispatchEvent(createEvent('preloaderEnd'))
        },
      })
      .to(
        preloader,
        { opacity: 0, duration: 0.2, pointerEvents: 'none' },
        '+=0.2'
      )
  } else {
    gsap.to(preloader, {
      opacity: 0,
      duration: 0.8,
      pointerEvents: 'none',
    })
  }
}
